import React from "react";
import Label from "../Label";
import { twMerge } from "tailwind-merge";

export default function Input({
  label = "",
  className = "",
  note = "",
  containerClass = "",
  noteClass = "",
  ...rest
}) {
  return (
    <div className={containerClass}>
      {label ? <Label className="text-base font-semibold">{label}</Label> : ""}
      <input
        className={`shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 mb-1 leading-tight focus:outline-none focus:shadow-outline ${className}`}
        {...rest}
      />
      {note && (
        <p className={twMerge("text-xs text-gray-600 italic", noteClass)}>
          {note}
        </p>
      )}
    </div>
  );
}